export default __webpack_public_path__ + "static/media/grayLogo.5393f107.svg";